import MatrixPageContainer from './MatrixPage';

export default MatrixPageContainer;
